import axiosInstance from "./axiosInstance";

// The chase list is loaded lean — a chase's timeline and logs are pulled in only when
// its row is actually expanded, which keeps the list request small and quick. Asking
// for one exact id is the same list query with the associations switched back on.
const fetchChaseDetail = async (id: number | string) => {
  const res = await axiosInstance.get(`/loan?id=${id}&lean=false`);
  const chase = res.data?.data?.[0];

  if (!chase) {
    return null;
  }

  // Only ever one row for an id, so the flag on the response belongs to this chase.
  return { ...chase, isSameCustomerChase: res.data?.isSameCustomerChase };
};

export default fetchChaseDetail;
